import { render, staticRenderFns } from "./AuthDocuments.vue?vue&type=template&id=18239f52"
import script from "./AuthDocuments.vue?vue&type=script&lang=js"
export * from "./AuthDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports